// src/components/auth/AuthLayout.jsx
import React from "react";

const TILES = [
  {
    label: "Screen Damage",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <rect x="5" y="2" width="14" height="20" rx="2"/>
        <line x1="9" y1="7" x2="15" y2="13"/>
        <line x1="9" y1="10" x2="12" y2="13"/>
      </svg>
    ),
  },
  {
    label: "Extended Warranty",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.8l-4.9 2.4.9-5.5L4 7.8l5.5-.8z"/>
      </svg>
    ),
  },
  {
    label: "Accidental Cover",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
  },
  {
    label: "Water Damage",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <path d="M12 2C6 10 4 14 4 17a8 8 0 0016 0c0-3-2-7-8-15z"/>
      </svg>
    ),
  },
  {
    label: "Theft Protection",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <rect x="3" y="11" width="18" height="11" rx="2"/>
        <path d="M7 11V7a5 5 0 0110 0v4"/>
        <circle cx="12" cy="16" r="1" fill="white"/>
      </svg>
    ),
  },
  {
    label: "Battery Cover",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <rect x="2" y="7" width="18" height="10" rx="2"/>
        <path d="M22 11v2"/>
        <line x1="6" y1="12" x2="10" y2="12"/>
        <line x1="8" y1="10" x2="8" y2="14"/>
      </svg>
    ),
  },
  {
    label: "Free Repair",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l2.8-2.8a6 6 0 01-7.9 7.9l-5.5 5.5a2.1 2.1 0 01-3-3l5.5-5.5a6 6 0 017.9-7.9l-2.8 2.8z"/>
      </svg>
    ),
  },
  {
    label: "Dead Pixel",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
        <circle cx="9" cy="10" r="1.5" fill="white"/>
        <line x1="12" y1="7" x2="15" y2="13"/>
      </svg>
    ),
  },
  {
    label: "Surge Protect",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
  {
    label: "Home Pickup",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
  },
  {
    label: "No Cost EMI",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <rect x="1" y="4" width="22" height="16" rx="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
        <line x1="8" y1="15" x2="10" y2="15"/>
        <line x1="12" y1="15" x2="16" y2="15"/>
      </svg>
    ),
  },
  {
    label: "Total Loss",
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
        <circle cx="12" cy="12" r="10"/>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
      </svg>
    ),
  },
  // INDEX 12: THE LOGO TILE
  {
    isLogo: true
  }
];

// Staggered the logo (12) so it looks like a beautiful woven pattern instead of a horizontal wall
const COLUMNS = [
  { indices: [0, 1, 12, 3, 4, 5],     anim: "animate-col-down" }, // Logo is 3rd
  { indices: [6, 7, 8, 9, 12, 10],    anim: "animate-col-up" },   // Logo is 5th
  { indices: [12, 11, 0, 1, 2, 3],    anim: "animate-col-down-slow" }, // Logo is 1st
];

function Tile({ svg, label, isLogo, topLogo }) {
  // If this is the special logo tile, render the logo instead of an icon
  if (isLogo) {
    return (
      <div className="flex items-center justify-center rounded-2xl bg-white/20 border-2 border-white/40 backdrop-blur-md p-3 min-h-[80px] w-full shadow-lg">
        {topLogo ? (
          <img 
            src={topLogo} 
            alt="Logo" 
            className="max-h-[45px] w-auto object-contain brightness-0 invert drop-shadow-[0_4px_8px_rgba(0,0,0,0.2)]" 
          />
        ) : (
          <div className="text-center">
            <span className="text-[12px] font-black text-white uppercase tracking-widest leading-none drop-shadow-md">
              Warranty<br/>Mitra
            </span>
          </div>
        )}
      </div>
    );
  }

  // Otherwise, render the normal tile
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white/10 border border-white/20 backdrop-blur-sm p-3 min-h-[80px] w-full">
      <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/20">
        {svg}
      </div>
      <span className="text-[8px] font-bold uppercase tracking-wider text-white text-center leading-tight">
        {label}
      </span>
    </div>
  );
}

export default function AuthLayout({ children, topLogo }) {
  return (
    <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">

      {/* ── GREEN HERO PANEL ── */}
      <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-br from-emerald-400 via-emerald-600 to-emerald-900">

        {/* Scrolling tile columns */}
        <div className="absolute inset-0 top-[-15%] flex gap-3 px-2 -rotate-[55deg] scale-[1.4] origin-center">
          {COLUMNS.map((col, ci) => (
            <div key={ci} className={`flex flex-col gap-3 flex-1 ${col.anim}`}>
              {[...col.indices, ...col.indices].map((ti, i) => (
                <Tile key={i} {...TILES[ti]} topLogo={topLogo} />
              ))}
            </div>
          ))}
        </div>

        {/* Bottom fade into the form sheet */}
        <div className="absolute bottom-0 left-0 w-full h-28 bg-gradient-to-b from-transparent to-emerald-900/90 pointer-events-none" />
      </div>

      {/* ── FORM BOTTOM SHEET ── */}
      <div className="relative z-20 flex-1 flex flex-col justify-end pt-[50vh]">
        <div className="bg-white rounded-t-[28px] shadow-2xl min-h-[52vh]">
          {children}
        </div>
      </div>

      {/* ── SCROLL ANIMATIONS ── */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes col-down {
          0%   { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        @keyframes col-up {
          0%   { transform: translateY(-50%); }
          100% { transform: translateY(0); }
        }
        .animate-col-down      { animation: col-down 20s linear infinite; }
        .animate-col-up        { animation: col-up 25s linear infinite; }
        .animate-col-down-slow { animation: col-down 16s linear infinite; animation-delay: -6s; }
      `}} />
    </div>
  );
}
//*********************************************************************************************** */
// // src/components/auth/AuthLayout.jsx

// const TILES = [
//   {
//     label: "Screen Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="5" y="2" width="14" height="20" rx="2"/>
//         <line x1="9" y1="7" x2="15" y2="13"/>
//         <line x1="9" y1="10" x2="12" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Extended Warranty",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.8l-4.9 2.4.9-5.5L4 7.8l5.5-.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Accidental Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
//         <path d="M9 12l2 2 4-4"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Water Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 2C6 10 4 14 4 17a8 8 0 0016 0c0-3-2-7-8-15z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Theft Protection",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="3" y="11" width="18" height="11" rx="2"/>
//         <path d="M7 11V7a5 5 0 0110 0v4"/>
//         <circle cx="12" cy="16" r="1" fill="white"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Battery Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="2" y="7" width="18" height="10" rx="2"/>
//         <path d="M22 11v2"/>
//         <line x1="6" y1="12" x2="10" y2="12"/>
//         <line x1="8" y1="10" x2="8" y2="14"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Free Repair",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l2.8-2.8a6 6 0 01-7.9 7.9l-5.5 5.5a2.1 2.1 0 01-3-3l5.5-5.5a6 6 0 017.9-7.9l-2.8 2.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Dead Pixel",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="2" y="3" width="20" height="14" rx="2"/>
//         <path d="M8 21h8M12 17v4"/>
//         <circle cx="9" cy="10" r="1.5" fill="white"/>
//         <line x1="12" y1="7" x2="15" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Surge Protect",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Home Pickup",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
//         <polyline points="9 22 9 12 15 12 15 22"/>
//       </svg>
//     ),
//   },
//   {
//     label: "No Cost EMI",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="1" y="4" width="22" height="16" rx="2"/>
//         <line x1="1" y1="10" x2="23" y2="10"/>
//         <line x1="8" y1="15" x2="10" y2="15"/>
//         <line x1="12" y1="15" x2="16" y2="15"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Total Loss",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <circle cx="12" cy="12" r="10"/>
//         <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
//       </svg>
//     ),
//   },
//   {
//     isLogo: true
//   }
// ];

// const COLUMNS = [
//   { indices: [0, 1, 2, 12, 3, 4],    anim: "animate-col-down" },
//   { indices: [4, 5, 6, 12, 7, 8],    anim: "animate-col-up" },
//   { indices: [8, 9, 10, 12, 11, 0],  anim: "animate-col-down-slow" }, // <--- Fixed the double comma here
// ];

// // function Tile({ svg, label }) {
// //   return (
// //     <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white/15 border border-white/25 backdrop-blur-sm p-3 min-h-[80px] w-full">
// //       {/* Icon */}
// //       <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/20">
// //         {svg}
// //       </div>
// //       {/* Label */}
// //       <span className="text-[8px] font-bold uppercase tracking-wider text-white text-center leading-tight">
// //         {label}
// //       </span>
// //     </div>
// //   );
// // }

// function Tile({ svg, label, isLogo, topLogo }) {
//   // If this is the special logo tile, render the logo instead of an icon
//   if (isLogo) {
//     return (
//       <div className="flex items-center justify-center rounded-2xl bg-white/20 border-2 border-white/40 backdrop-blur-md p-3 min-h-[80px] w-full shadow-lg">
//         {topLogo ? (
//           <img 
//             src={topLogo} 
//             alt="Logo" 
//             className="max-h-[50px] w-auto object-contain brightness-0 invert drop-shadow-md" 
//           />
//         ) : (
//           <div className="text-center">
//             <span className="text-[12px] font-black text-white uppercase tracking-widest leading-none drop-shadow-md">
//               Warranty<br/>Mitra
//             </span>
//           </div>
//         )}
//       </div>
//     );
//   }

//   // Otherwise, render the normal tile
//   return (
//     <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white/15 border border-white/25 backdrop-blur-sm p-3 min-h-[80px] w-full">
//       <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/20">
//         {svg}
//       </div>
//       <span className="text-[8px] font-bold uppercase tracking-wider text-white text-center leading-tight">
//         {label}
//       </span>
//     </div>
//   );
// }
// export default function AuthLayout({ children, topLogo }) {
//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">

//       {/* ── GREEN HERO PANEL ── */}
//     {/* ── GREEN HERO PANEL ── */}
// <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-br from-emerald-400 via-emerald-600 to-emerald-900">

//   {/* Scrolling tile columns */}
//   <div className="absolute inset-0 top-[-15%] flex gap-3 px-2 -rotate-[55deg] scale-[1.4] origin-center">
//     {COLUMNS.map((col, ci) => (
//       <div key={ci} className={`flex flex-col gap-3 flex-1 ${col.anim}`}>
//         {[...col.indices, ...col.indices].map((ti, i) => (
//           <Tile key={i} {...TILES[ti]} topLogo={topLogo} />
//         ))}
//       </div>
//     ))}
//   </div>

//   {/* Bottom fade */}
//   <div className="absolute bottom-0 left-0 w-full h-28 bg-gradient-to-b from-transparent to-emerald-900/90" />

//   {/* ── LOGO — no box, just white logo centered ── */}
//   <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none pb-10">
    
//     {/* Soft glow circle behind logo */}
//     <div className="absolute w-48 h-48 rounded-full bg-white/15 blur-[40px]" />

//     {/* <div className="relative z-10 flex flex-col items-center gap-2">
//       {topLogo ? (
//         <>
//           <img
//             src={topLogo}
//             alt="Logo"
//             className="max-w-[200px] max-h-[70px] object-contain brightness-0 invert drop-shadow-lg"
//           />
//         </>
//       ) : (
//         <>
//           <p className="text-2xl font-black text-white tracking-tight drop-shadow-lg">
//             YourBrand
//           </p>
//           <p className="text-[10px] font-semibold tracking-[0.22em] text-white/70 uppercase">
//             Protection Plans
//           </p>
//         </>
//       )}
//     </div> */}
//   </div>
// </div>

//       {/* ── FORM BOTTOM SHEET ── */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[50vh]">
//         <div className="bg-white rounded-t-[28px] shadow-2xl min-h-[52vh]">
//           {children}
//         </div>
//       </div>

//       {/* ── SCROLL ANIMATIONS ── */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes col-down {
//           0%   { transform: translateY(0); }
//           100% { transform: translateY(-50%); }
//         }
//         @keyframes col-up {
//           0%   { transform: translateY(-50%); }
//           100% { transform: translateY(0); }
//         }
//         .animate-col-down      { animation: col-down 20s linear infinite; }
//         .animate-col-up        { animation: col-up 25s linear infinite; }
//         .animate-col-down-slow { animation: col-down 16s linear infinite; animation-delay: -6s; }
//       `}} />
//     </div>
//   );
// }
//******************************+*******************working code phase 1 27-04-26********************************************** */
// // src/components/auth/AuthLayout.jsx

// const TILES = [
//   {
//     label: "Screen Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <rect x="5" y="2" width="14" height="20" rx="2"/>
//         <line x1="9" y1="7" x2="15" y2="13"/>
//         <line x1="9" y1="10" x2="12" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Extended Warranty",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
//         <path d="M9 12l2 2 4-4"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Accidental Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.8l-4.9 2.4.9-5.5L4 7.8l5.5-.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Water Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <path d="M12 2C6 10 4 14 4 17a8 8 0 0016 0c0-3-2-7-8-15z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Theft Protection",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <rect x="3" y="11" width="18" height="11" rx="2"/>
//         <path d="M7 11V7a5 5 0 0110 0v4"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Battery Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <rect x="2" y="7" width="18" height="10" rx="2"/>
//         <path d="M22 11v2"/>
//         <line x1="6" y1="12" x2="10" y2="12"/>
//         <line x1="8" y1="10" x2="8" y2="14"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Free Repair",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l2.8-2.8a6 6 0 01-7.9 7.9l-5.5 5.5a2.1 2.1 0 01-3-3l5.5-5.5a6 6 0 017.9-7.9l-2.8 2.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Dead Pixel",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <rect x="2" y="3" width="20" height="14" rx="2"/>
//         <path d="M8 21h8M12 17v4"/>
//         <line x1="12" y1="7" x2="15" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Surge Protect",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Home Pickup",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
//         <polyline points="9 22 9 12 15 12 15 22"/>
//       </svg>
//     ),
//   },
//   {
//     label: "No Cost EMI",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <rect x="1" y="4" width="22" height="16" rx="2"/>
//         <line x1="1" y1="10" x2="23" y2="10"/>
//         <line x1="8" y1="15" x2="10" y2="15"/>
//         <line x1="12" y1="15" x2="16" y2="15"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Total Loss",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//         <circle cx="12" cy="12" r="10"/>
//         <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
//       </svg>
//     ),
//   },
// ];

// const COLUMNS = [
//   { indices: [0, 1, 2, 3, 4],   anim: "animate-col-down" },
//   { indices: [4, 5, 6, 7, 8],   anim: "animate-col-up" },
//   { indices: [8, 9, 10, 11, 0], anim: "animate-col-down-slow" },
// ];

// function Tile({ svg, label }) {
//   return (
//     <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-green-50 border border-green-100 p-3 min-h-[76px] w-full">
//       {/* Icon bubble */}
//       <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-green-100">
//         {svg}
//       </div>
//       {/* Label */}
//       <span className="text-[7.5px] font-bold uppercase tracking-wider text-green-700 text-center leading-tight">
//         {label}
//       </span>
//     </div>
//   );
// }

// export default function AuthLayout({ children, topLogo }) {
//   return (
//     <div className="min-h-screen w-full relative bg-white flex flex-col overflow-hidden">

//       {/* ── WHITE HERO PANEL ── */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-white">

//         {/* Scrolling tile columns */}
//         <div className="absolute inset-0 top-[-15%] flex gap-3 px-2 -rotate-[55deg] scale-[1.35] origin-center">
//           {COLUMNS.map((col, ci) => (
//             <div key={ci} className={`flex flex-col gap-3 flex-1 ${col.anim}`}>
//               {[...col.indices, ...col.indices].map((ti, i) => (
//                 <Tile key={i} {...TILES[ti]} />
//               ))}
//             </div>
//           ))}
//         </div>

//         {/* Edge fades — all 4 sides */}
//         <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-white to-transparent z-10 pointer-events-none" />
//         <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-b from-transparent to-white z-10 pointer-events-none" />
//         <div className="absolute top-0 bottom-0 left-0 w-10 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
//         <div className="absolute top-0 bottom-0 right-0 w-10 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

//         {/* ── CENTERED LOGO ── */}
//         <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none pb-10">
//           <div className=" border border-green-100 rounded-2xl px-8 py-5  shadow-green-100 flex flex-col items-center gap-1">
//             {topLogo ? (
//               <img
//                 src={topLogo}
//                 alt="Logo"
//                 className="max-w-[180px] max-h-[60px] object-contain"
//               />
//             ) : (
//               <>
//                 <p className="text-xl font-black text-green-700 tracking-tight">
//                   YourBrand
//                 </p>
//                 <p className="text-[9px] font-semibold tracking-[0.22em] text-green-400 uppercase">
//                   Protection Plans
//                 </p>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ── FORM BOTTOM SHEET ── */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[50vh]">
//         <div className="bg-white rounded-t-[28px] shadow-2xl border-t border-green-50 min-h-[52vh]">
//           {children}
//         </div>
//       </div>

//       {/* ── SCROLL ANIMATIONS ── */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes col-down {
//           0%   { transform: translateY(0); }
//           100% { transform: translateY(-50%); }
//         }
//         @keyframes col-up {
//           0%   { transform: translateY(-50%); }
//           100% { transform: translateY(0); }
//         }
//         .animate-col-down      { animation: col-down 20s linear infinite; }
//         .animate-col-up        { animation: col-up 25s linear infinite; }
//         .animate-col-down-slow { animation: col-down 16s linear infinite; animation-delay: -6s; }
//       `}} />
//     </div>
//   );
// }
//********************************************working code phase 1 27/04/26*********************************************** */
// // src/components/auth/AuthLayout.jsx

// const TILES = [
//   {
//     label: "Screen Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="5" y="2" width="14" height="20" rx="2"/>
//         <line x1="9" y1="7" x2="15" y2="13"/>
//         <line x1="9" y1="10" x2="12" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Extended Warranty",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.8l-4.9 2.4.9-5.5L4 7.8l5.5-.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Accidental Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
//         <path d="M9 12l2 2 4-4"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Water Damage",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M12 2C6 10 4 14 4 17a8 8 0 0016 0c0-3-2-7-8-15z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Theft Protection",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="3" y="11" width="18" height="11" rx="2"/>
//         <path d="M7 11V7a5 5 0 0110 0v4"/>
//         <circle cx="12" cy="16" r="1" fill="white"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Battery Cover",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="2" y="7" width="18" height="10" rx="2"/>
//         <path d="M22 11v2"/>
//         <line x1="6" y1="12" x2="10" y2="12"/>
//         <line x1="8" y1="10" x2="8" y2="14"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Free Repair",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l2.8-2.8a6 6 0 01-7.9 7.9l-5.5 5.5a2.1 2.1 0 01-3-3l5.5-5.5a6 6 0 017.9-7.9l-2.8 2.8z"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Dead Pixel",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="2" y="3" width="20" height="14" rx="2"/>
//         <path d="M8 21h8M12 17v4"/>
//         <circle cx="9" cy="10" r="1.5" fill="white"/>
//         <line x1="12" y1="7" x2="15" y2="13"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Surge Protect",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Home Pickup",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
//         <polyline points="9 22 9 12 15 12 15 22"/>
//       </svg>
//     ),
//   },
//   {
//     label: "No Cost EMI",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <rect x="1" y="4" width="22" height="16" rx="2"/>
//         <line x1="1" y1="10" x2="23" y2="10"/>
//         <line x1="8" y1="15" x2="10" y2="15"/>
//         <line x1="12" y1="15" x2="16" y2="15"/>
//       </svg>
//     ),
//   },
//   {
//     label: "Total Loss",
//     svg: (
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//         <circle cx="12" cy="12" r="10"/>
//         <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
//       </svg>
//     ),
//   },
// ];

// const COLUMNS = [
//   { indices: [0, 1, 2, 3, 4],   anim: "animate-col-down" },
//   { indices: [4, 5, 6, 7, 8],   anim: "animate-col-up" },
//   { indices: [8, 9, 10, 11, 0], anim: "animate-col-down-slow" },
// ];

// function Tile({ svg, label }) {
//   return (
//     <div className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white/15 border border-white/25 backdrop-blur-sm p-3 min-h-[80px] w-full">
//       {/* Icon */}
//       <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/20">
//         {svg}
//       </div>
//       {/* Label */}
//       <span className="text-[8px] font-bold uppercase tracking-wider text-white text-center leading-tight">
//         {label}
//       </span>
//     </div>
//   );
// }

// export default function AuthLayout({ children, topLogo }) {
//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">

//       {/* ── GREEN HERO PANEL ── */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-br from-emerald-400 via-emerald-600 to-emerald-900">

//         {/* Ambient glow orbs */}
//         <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-emerald-300/30 blur-[80px]" />
//         <div className="absolute top-20 -left-10 w-48 h-48 rounded-full bg-teal-300/20 blur-[60px]" />

//         {/* Scrolling tile columns — slight angle like video */}
//         <div className="absolute top-[-20%] inset-0 flex gap-3 px-2 -rotate-[55deg] scale-[1.3] origin-center blur-[0.5px]">
//           {COLUMNS.map((col, ci) => (
//             <div key={ci} className={`flex flex-col gap-3 flex-1 ${col.anim}`}>
//               {/* Duplicate for seamless infinite scroll */}
//               {[...col.indices, ...col.indices].map((ti, i) => (
//                 <Tile key={i} {...TILES[ti]} />
//               ))}
//             </div>
//           ))}
//         </div>

//         {/* Bottom fade into panel edge */}
//         <div className="absolute bottom-0 left-0 w-full h-28 bg-gradient-to-b from-transparent to-emerald-900/90" />

//         {/* ── CENTERED LOGO ── */}
//         <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none pb-10">
//           {/* White glow behind logo */}
//           <div className="absolute w-56 h-56 rounded-full bg-white/10 blur-[50px]" />

//           <div className="relative z-10 bg-white rounded-2xl px-8 py-5 shadow-2xl flex flex-col items-center gap-1">
//             {topLogo ? (
//               <img
//                 src={topLogo}
//                 alt="Logo"
//                 className="max-w-[180px] max-h-[60px] object-contain"
//               />
//             ) : (
//               <>
//                 {/* Replace below with your <img> logo */}
//                 <p className="text-xl font-black text-emerald-700 tracking-tight">
//                   YourBrand
//                 </p>
//                 <p className="text-[9px] font-semibold tracking-[0.22em] text-emerald-500 uppercase">
//                   Protection Plans
//                 </p>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ── FORM BOTTOM SHEET ── */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[50vh]">
//         <div className="bg-white rounded-t-[28px] shadow-2xl min-h-[52vh]">
//           {children}
//         </div>
//       </div>

//       {/* ── SCROLL ANIMATIONS ── */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes col-down {
//           0%   { transform: translateY(0); }
//           100% { transform: translateY(-50%); }
//         }
//         @keyframes col-up {
//           0%   { transform: translateY(-50%); }
//           100% { transform: translateY(0); }
//         }
//         .animate-col-down      { animation: col-down 20s linear infinite; }
//         .animate-col-up        { animation: col-up 25s linear infinite; }
//         .animate-col-down-slow { animation: col-down 16s linear infinite; animation-delay: -6s; }
//       `}} />
//     </div>
//   );
// }
//************************************************************************************************************ */
// // src/components/auth/AuthLayout.jsx

// const TILES = [
//   {
//     label: "Screen Damage",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <rect x="5" y="2" width="14" height="20" rx="2"/><line x1="9" y1="7" x2="15" y2="13"/><line x1="9" y1="10" x2="12" y2="13"/>
//     </svg>
//   },
//   {
//     label: "Extended Warranty",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.8l-4.9 2.4.9-5.5L4 7.8l5.5-.8z"/>
//     </svg>
//   },
//   {
//     label: "Accidental Cover",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>
//     </svg>
//   },
//   {
//     label: "Water Damage",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <path d="M12 2C6 10 4 14 4 17a8 8 0 0016 0c0-3-2-7-8-15z"/>
//     </svg>
//   },
//   {
//     label: "Theft Protection",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/><circle cx="12" cy="16" r="1" fill="white"/>
//     </svg>
//   },
//   {
//     label: "Battery Cover",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <rect x="2" y="7" width="18" height="10" rx="2"/><path d="M22 11v2"/><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/>
//     </svg>
//   },
//   {
//     label: "Free Repair",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l2.8-2.8a6 6 0 01-7.9 7.9l-5.5 5.5a2.1 2.1 0 01-3-3l5.5-5.5a6 6 0 017.9-7.9l-2.8 2.8z"/>
//     </svg>
//   },
//   {
//     label: "Dead Pixel",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><circle cx="9" cy="10" r="1.5" fill="white"/><line x1="12" y1="7" x2="15" y2="13"/>
//     </svg>
//   },
//   {
//     label: "Surge Protect",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//     </svg>
//   },
//   {
//     label: "Home Pickup",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
//     </svg>
//   },
//   {
//     label: "No Cost EMI",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/><line x1="8" y1="15" x2="10" y2="15"/><line x1="12" y1="15" x2="16" y2="15"/>
//     </svg>
//   },
//   {
//     label: "Total Loss",
//     svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-white">
//       <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
//     </svg>
//   },
// ];

// const COLUMNS = [
//   { indices: [0,1,2,3,4],  anim: "animate-col-down" },
//   { indices: [4,5,6,7,8],  anim: "animate-col-up" },
//   { indices: [8,9,10,11,0], anim: "animate-col-down-slow" },
// ];

// function Tile({ svg, label }) {
//   return (
//     <div className="flex flex-col items-center justify-center gap-1.5 rounded-2xl bg-white/15 border border-white/25 p-3 min-h-[74px]">
//       {svg}
//       <span className="text-[8.5px] font-bold uppercase tracking-wide text-white/90 text-center leading-tight">
//         {label}
//       </span>
//     </div>
//   );
// }

// export default function AuthLayout({ children, topLogo }) {
//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">

//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-br from-emerald-400 via-emerald-600 to-emerald-900">

//         {/* 3 vertical scrolling columns */}
//         <div className="absolute inset-0 flex gap-2.5 px-1.5 blur-[1px] -rotate-[60deg] scale-[1.28] origin-center">
//           {COLUMNS.map((col, ci) => (
//             <div key={ci} className={`flex flex-col gap-2 flex-1 ${col.anim}`}>
//               {[...col.indices, ...col.indices].map((ti, i) => (
//                 <Tile key={i} {...TILES[ti]} />
//               ))}
//             </div>
//           ))}
//         </div>

//         {/* Bottom fade */}
//         <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-b from-transparent to-emerald-900" />

//         {/* Logo */}
//         <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none pb-8">
//           <div className="bg-white border border-white/30 rounded-2xl px-8 py-4 text-center">
//             {topLogo
//               ? <img src={topLogo} alt="Logo" className="max-w-[200px] object-contain" />
//               : <>
//                   <p className="text-2xl font-black text-white">WarrantyCo</p>
//                   <p className="text-[9px] tracking-[0.2em] text-white/70 uppercase mt-1">Total Protection</p>
//                 </>
//             }
//           </div>
//         </div>
//       </div>

//       {/* Form bottom sheet */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[48vh]">
//         <div className="bg-white rounded-t-[28px] shadow-2xl">
//           {children}
//         </div>
//       </div>

//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes col-down { 0% { transform: translateY(0); } 100% { transform: translateY(-50%); } }
//         @keyframes col-up   { 0% { transform: translateY(-50%); } 100% { transform: translateY(0); } }
//         .animate-col-down      { animation: col-down 20s linear infinite; }
//         .animate-col-up        { animation: col-up 25s linear infinite; }
//         .animate-col-down-slow { animation: col-down 16s linear infinite; animation-delay: -6s; }
//       `}} />
//     </div>
//   );
// }
//************************************************************************************************ */
// // src/components/auth/AuthLayout.jsx
// import { Shield, Smartphone, Zap, Lock, Cpu, Wrench, Droplets, Umbrella } from "lucide-react";

// export default function AuthLayout({ children, topLogo }) {
//   // Simplified structured data
//   const row1Data = [
//     { type: 'icon', icon: Shield },
//     { type: 'icon', icon: Smartphone },
//     { type: 'text', label: 'EXTENDED WARRANTY' },
//     { type: 'icon', icon: Zap },
//     { type: 'icon', icon: Umbrella },
//     { type: 'text', label: 'SCREEN DAMAGE' },
//   ];

//   const row2Data = [
//     { type: 'icon', icon: Lock },
//     { type: 'icon', icon: Cpu },
//     { type: 'text', label: 'TOTAL PROTECTION' },
//     { type: 'icon', icon: Wrench },
//     { type: 'icon', icon: Droplets },
//     { type: 'text', label: 'ACCIDENTAL COVER' },
//   ];

//   // Render items using Premium Glassmorphism
//   const renderMarqueeItem = (item, index) => {
//     // Shared glassmorphism base styles
//     const glassBase = "flex items-center justify-center rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 shadow-[0_8px_32px_rgba(0,0,0,0.08)] relative overflow-hidden";

//     if (item.type === 'icon') {
//       const Icon = item.icon;
//       return (
//         <div key={index} className={`${glassBase} w-20 h-20 sm:w-24 sm:h-24`}>
//           {/* Subtle inner top-light for 3D edge */}
//           <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/40 to-transparent" />
//           <Icon size={40} strokeWidth={2} className="text-white drop-shadow-md" />
//         </div>
//       );
//     }
//     return (
//       <div key={index} className={`${glassBase} px-8 h-20 sm:h-24`}>
//         {/* Subtle inner top-light for 3D edge */}
//         <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/40 to-transparent" />
//         <span className="font-black uppercase tracking-[0.2em] text-[10px] sm:text-xs whitespace-nowrap text-white/95 drop-shadow-sm">
//           {item.label}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">
      
//       {/* PREMIUM ANIMATED BACKGROUND SECTION */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-br from-emerald-300 via-emerald-400 to-emerald-600">
        
//         {/* 1. MESH ORBS (Colorful under-glow that passes through the glass) */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-emerald-100/40 blur-[90px] animate-pulse" />
//         <div className="absolute top-[30%] -left-[10%] w-[50%] h-[50%] rounded-full bg-teal-200/30 blur-[100px] animate-pulse" style={{ animationDelay: '1.5s' }} />
//         <div className="absolute bottom-[10%] left-[20%] w-[40%] h-[40%] rounded-full bg-white/20 blur-[80px] animate-pulse" style={{ animationDelay: '3s' }} />

//         {/* 2. DIAGONAL MARQUEE ROWS */}
//         <div className="absolute inset-0 flex flex-col justify-center gap-16 sm:gap-20 -rotate-[12deg] scale-[1.3] pointer-events-none z-0 blur-[1px]">
          
//           {/* Row 1: Bottom Right to Top Left */}
//           <div className="flex w-max animate-marquee-slow">
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-a-${i}`))}
//             </div>
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-b-${i}`))}
//             </div>
//           </div>

//           {/* Row 2: Top Left to Bottom Right */}
//           <div className="flex w-max animate-marquee-reverse-slow">
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-a-${i}`))}
//             </div>
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-b-${i}`))}
//             </div>
//           </div>
//         </div>

//         {/* 3. CENTERED LOGO LAYER */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16 z-10 pointer-events-none">
//           <div className="absolute w-[300px] h-[300px] bg-emerald-500/30 rounded-full blur-[80px] opacity-100 mix-blend-screen" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-1000 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_16px_32px_rgba(0,0,0,0.25)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[45vh] max-w-md mx-auto w-full">
//         {children}
//       </div>

//       {/* CUSTOM ANIMATION STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0); }
//         }
//         .animate-marquee-slow {
//           animation: marquee 40s linear infinite;
//         }
//         .animate-marquee-reverse-slow {
//           animation: marquee-reverse 45s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// }
//************************************************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { Shield, Smartphone, Zap, CheckCircle, Lock, Cpu, Wrench, Droplets, Umbrella } from "lucide-react";

// export default function AuthLayout({ children, topLogo }) {
//   // Define structured data for Row 1
//   const row1Data = [
//     { type: 'icon', icon: Shield, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'icon', icon: Smartphone, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'text', label: 'EXTENDED WARRANTY', textColor: 'text-blue-700', bgColor: 'bg-white', borderColor: 'border-blue-200' },
//     { type: 'icon', icon: Zap, iconColor: 'text-amber-500', bgColor: 'bg-amber-50', borderColor: 'border-amber-100' },
//     { type: 'icon', icon: Umbrella, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'text', label: 'SCREEN DAMAGE', textColor: 'text-rose-600', bgColor: 'bg-white', borderColor: 'border-rose-200' },
//   ];

//   // Define structured data for Row 2
//   const row2Data = [
//     { type: 'icon', icon: Lock, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'icon', icon: Cpu, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'text', label: 'TOTAL PROTECTION', textColor: 'text-emerald-700', bgColor: 'bg-white', borderColor: 'border-emerald-200' },
//     { type: 'icon', icon: Wrench, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'icon', icon: Droplets, iconColor: 'text-cyan-600', bgColor: 'bg-cyan-50', borderColor: 'border-cyan-100' },
//     { type: 'text', label: 'ACCIDENTAL COVER', textColor: 'text-indigo-600', bgColor: 'bg-white', borderColor: 'border-indigo-200' },
//   ];

//   // Helper function to render items
//   const renderMarqueeItem = (item, index) => {
//     if (item.type === 'icon') {
//       const Icon = item.icon;
//       return (
//         <div key={index} className={`flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//           <Icon size={40} strokeWidth={2.5} className={item.iconColor} />
//         </div>
//       );
//     }
//     return (
//       <div key={index} className={`flex items-center justify-center px-8 h-20 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//         <span className={`font-black uppercase tracking-[0.15em] text-xs sm:text-sm whitespace-nowrap ${item.textColor}`}>
//           {item.label}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen w-full relative bg-blue-500 flex flex-col overflow-hidden">
      
//       {/* PREMIUM ANIMATED BACKGROUND SECTION */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-blue-200 to-ember-500">
        
//         {/* MESH ORBS */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-blue-600/10 blur-[90px] animate-pulse" />
//         <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-slate-300/20 blur-[100px] animate-pulse" style={{ animationDelay: '1s' }} />

//         {/* DIAGONAL MARQUEE ROWS - Added blur-[2px] and opacity-70 for depth of field */}
//         <div className="absolute inset-0 flex flex-col justify-center gap-20 -rotate-[12deg] scale-[1.25] pointer-events-none z-0 top-[-20%] blur-[1px] opacity-90">
          
//           {/* Row 1: Bottom Right to Top Left */}
//           <div className="flex w-max animate-marquee-slow">
//             {/* Block 1 */}
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-a-${i}`))}
//             </div>
//             {/* Block 2 (Duplicate for seamless loop) */}
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-b-${i}`))}
//             </div>
//           </div>

//           {/* Row 2: Top Left to Bottom Right */}
//           <div className="flex w-max animate-marquee-reverse-slow">
//             {/* Block 1 */}
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-a-${i}`))}
//             </div>
//             {/* Block 2 (Duplicate for seamless loop) */}
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-b-${i}`))}
//             </div>
//           </div>
//         </div>

//         {/* CENTERED LOGO LAYER */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16 z-10 pointer-events-none">
//           <div className="absolute w-[280px] h-[280px] bg-white rounded-full blur-[80px] opacity-90" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-1000 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_12px_24px_rgba(37,99,235,0.12)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[45vh] max-w-md mx-auto w-full">
//         {children}
//       </div>

//       {/* CUSTOM ANIMATION STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0); }
//         }
//         .animate-marquee-slow {
//           animation: marquee 35s linear infinite;
//         }
//         .animate-marquee-reverse-slow {
//           animation: marquee-reverse 40s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// }
//******************************************************************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { Shield, Smartphone, Zap, CheckCircle, Lock, Cpu, Wrench, Droplets, Umbrella } from "lucide-react";

// export default function AuthLayout({ children, topLogo }) {
//   // Define structured data for Row 1
//   const row1Data = [
//     { type: 'icon', icon: Shield, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'icon', icon: Smartphone, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'text', label: 'EXTENDED WARRANTY', textColor: 'text-blue-700', bgColor: 'bg-white', borderColor: 'border-blue-200' },
//     { type: 'icon', icon: Zap, iconColor: 'text-amber-500', bgColor: 'bg-amber-50', borderColor: 'border-amber-100' },
//     { type: 'icon', icon: Umbrella, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'text', label: 'SCREEN DAMAGE', textColor: 'text-rose-600', bgColor: 'bg-white', borderColor: 'border-rose-200' },
//   ];

//   // Define structured data for Row 2
//   const row2Data = [
//     { type: 'icon', icon: Lock, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'icon', icon: Cpu, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'text', label: 'TOTAL PROTECTION', textColor: 'text-emerald-700', bgColor: 'bg-white', borderColor: 'border-emerald-200' },
//     { type: 'icon', icon: Wrench, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'icon', icon: Droplets, iconColor: 'text-cyan-600', bgColor: 'bg-cyan-50', borderColor: 'border-cyan-100' },
//     { type: 'text', label: 'ACCIDENTAL COVER', textColor: 'text-indigo-600', bgColor: 'bg-white', borderColor: 'border-indigo-200' },
//   ];

//   // Helper function to render items
//   const renderMarqueeItem = (item, index) => {
//     if (item.type === 'icon') {
//       const Icon = item.icon;
//       return (
//         <div key={index} className={`flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//           <Icon size={40} strokeWidth={2.5} className={item.iconColor} />
//         </div>
//       );
//     }
//     return (
//       <div key={index} className={`flex items-center justify-center px-8 h-20 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//         <span className={`font-black uppercase tracking-[0.15em] text-xs sm:text-sm whitespace-nowrap ${item.textColor}`}>
//           {item.label}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">
      
//       {/* PREMIUM ANIMATED BACKGROUND SECTION */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-white to-slate-50">
        
//         {/* MESH ORBS */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-blue-600/10 blur-[90px] animate-pulse" />
//         <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-slate-300/20 blur-[100px] animate-pulse" style={{ animationDelay: '1s' }} />

//         {/* DIAGONAL MARQUEE ROWS */}
//         <div className="absolute inset-0 flex flex-col justify-center gap-8 -rotate-[12deg] scale-[1.25] pointer-events-none z-0">
          
//           {/* Row 1: Bottom Right to Top Left */}
//           <div className="flex w-max animate-marquee-slow">
//             {/* Block 1 */}
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-a-${i}`))}
//             </div>
//             {/* Block 2 (Duplicate for seamless loop) */}
//             <div className="flex gap-8 pr-8">
//               {row1Data.map((item, i) => renderMarqueeItem(item, `r1-b-${i}`))}
//             </div>
//           </div>

//           {/* Row 2: Top Left to Bottom Right */}
//           <div className="flex w-max animate-marquee-reverse-slow">
//             {/* Block 1 */}
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-a-${i}`))}
//             </div>
//             {/* Block 2 (Duplicate for seamless loop) */}
//             <div className="flex gap-8 pr-8">
//               {row2Data.map((item, i) => renderMarqueeItem(item, `r2-b-${i}`))}
//             </div>
//           </div>
//         </div>

//         {/* CENTERED LOGO LAYER */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16 z-10 pointer-events-none">
//           <div className="absolute w-[280px] h-[280px] bg-white rounded-full blur-[80px] opacity-90" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-1000 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_12px_24px_rgba(37,99,235,0.12)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[40vh] max-w-md mx-auto w-full">
//         {children}
//       </div>

//       {/* CUSTOM ANIMATION STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0); }
//         }
//         .animate-marquee-slow {
//           animation: marquee 35s linear infinite;
//         }
//         .animate-marquee-reverse-slow {
//           animation: marquee-reverse 40s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// }
//***************************************************************************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { Shield, Smartphone, Zap, CheckCircle, Lock, Cpu, Wrench, Droplets, Umbrella } from "lucide-react";

// export default function AuthLayout({ children, topLogo }) {
//   // Define structured data for Row 1 (2 Icons -> 1 Text pattern)
//   const row1Data = [
//     { type: 'icon', icon: Shield, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'icon', icon: Smartphone, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'text', label: 'EXTENDED WARRANTY', textColor: 'text-blue-700', bgColor: 'bg-white', borderColor: 'border-blue-200' },
//     { type: 'icon', icon: Zap, iconColor: 'text-amber-500', bgColor: 'bg-amber-50', borderColor: 'border-amber-100' },
//     { type: 'icon', icon: Umbrella, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'text', label: 'SCREEN DAMAGE', textColor: 'text-rose-600', bgColor: 'bg-white', borderColor: 'border-rose-200' },
//   ];

//   // Define structured data for Row 2 (2 Icons -> 1 Text pattern)
//   const row2Data = [
//     { type: 'icon', icon: Lock, iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50', borderColor: 'border-emerald-100' },
//     { type: 'icon', icon: Cpu, iconColor: 'text-blue-600', bgColor: 'bg-blue-50', borderColor: 'border-blue-100' },
//     { type: 'text', label: 'TOTAL PROTECTION', textColor: 'text-emerald-700', bgColor: 'bg-white', borderColor: 'border-emerald-200' },
//     { type: 'icon', icon: Wrench, iconColor: 'text-slate-600', bgColor: 'bg-slate-100', borderColor: 'border-slate-200' },
//     { type: 'icon', icon: Droplets, iconColor: 'text-cyan-600', bgColor: 'bg-cyan-50', borderColor: 'border-cyan-100' },
//     { type: 'text', label: 'ACCIDENTAL COVER', textColor: 'text-indigo-600', bgColor: 'bg-white', borderColor: 'border-indigo-200' },
//   ];

//   // Helper function to render items consistently based on your design system
//   const renderMarqueeItem = (item, index) => {
//     if (item.type === 'icon') {
//       const Icon = item.icon;
//       return (
//         <div key={index} className={`flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//           <Icon size={40} strokeWidth={2.5} className={item.iconColor} />
//         </div>
//       );
//     }
//     return (
//       <div key={index} className={`flex items-center justify-center px-8 h-20 sm:h-24 rounded-2xl border shadow-sm ${item.bgColor} ${item.borderColor}`}>
//         <span className={`font-black uppercase tracking-[0.15em] text-xs sm:text-sm whitespace-nowrap ${item.textColor}`}>
//           {item.label}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen w-full relative bg-slate-50 flex flex-col overflow-hidden">
      
//       {/* PREMIUM ANIMATED BACKGROUND SECTION */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-white to-slate-50">
        
//         {/* 1. MESH ORBS (Deep Depth) */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-blue-600/10 blur-[90px] animate-pulse" />
//         <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-slate-300/20 blur-[100px] animate-pulse" style={{ animationDelay: '1s' }} />

//         {/* 2. DIAGONAL MARQUEE ROWS */}
//         <div className="absolute inset-0 flex flex-col justify-center gap-8 -rotate-[12deg] scale-[1.25] pointer-events-none z-0">
          
//           {/* Row 1: Bottom Right to Top Left */}
//           <div className="flex w-max gap-8 animate-marquee-slow">
//             {[...row1Data, ...row1Data].map((item, i) => renderMarqueeItem(item, `r1-${i}`))}
//           </div>

//           {/* Row 2: Top Left to Bottom Right */}
//           <div className="flex w-max gap-8 animate-marquee-reverse-slow">
//             {[...row2Data, ...row2Data].map((item, i) => renderMarqueeItem(item, `r2-${i}`))}
//           </div>
//         </div>

//         {/* 3. CENTERED LOGO LAYER */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16 z-10 pointer-events-none">
//           <div className="absolute w-[280px] h-[280px] bg-white rounded-full blur-[80px] opacity-90" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-1000 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_12px_24px_rgba(37,99,235,0.12)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[40vh] max-w-md mx-auto w-full">
//         {children}
//       </div>

//       {/* CUSTOM ANIMATION STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0); }
//         }
//         .animate-marquee-slow {
//           animation: marquee 35s linear infinite;
//         }
//         .animate-marquee-reverse-slow {
//           animation: marquee-reverse 40s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// }
//***************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { Shield, Smartphone, Zap, Award, CheckCircle, Lock, Settings, Cpu } from "lucide-react";

// export default function AuthLayout({ children, topLogo }) {
//   // Define icons for the marquee rows
//   const iconsRow1 = [Shield, Smartphone, Zap, Award, CheckCircle];
//   const iconsRow2 = [Lock, Settings, Cpu, Shield, Zap];

//   return (
//     <div className="min-h-screen w-full relative bg-[#f4fbf6] flex flex-col overflow-hidden">
      
//       {/* PREMIUM ANIMATED BACKGROUND SECTION */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-white to-[#e6f4ea]">
        
//         {/* 1. MESH ORBS (Deep Depth) */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#bbf7d0] blur-[90px] opacity-60 animate-pulse" />
//         <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-[#86efac] blur-[100px] opacity-40 animate-pulse" style={{ animationDelay: '1s' }} />

//         {/* 2. DIAGONAL MARQUEE ROWS */}
//         <div className="absolute inset-0 flex flex-col justify-center gap-12 opacity-[0.08] -rotate-[12deg] scale-125 pointer-events-none">
          
//           {/* Row 1: Bottom Right to Top Left */}
//           <div className="flex whitespace-nowrap animate-marquee-slow">
//             {[...iconsRow1, ...iconsRow1, ...iconsRow1].map((Icon, i) => (
//               <div key={i} className="mx-6 p-4 bg-emerald-600/20 rounded-2xl border border-emerald-600/30">
//                 <Icon size={48} strokeWidth={1.5} className="text-emerald-700" />
//               </div>
//             ))}
//           </div>

//           {/* Row 2: Top Left to Bottom Right */}
//           <div className="flex whitespace-nowrap animate-marquee-reverse-slow">
//             {[...iconsRow2, ...iconsRow2, ...iconsRow2].map((Icon, i) => (
//               <div key={i} className="mx-6 p-4 bg-emerald-600/20 rounded-2xl border border-emerald-600/30">
//                 <Icon size={48} strokeWidth={1.5} className="text-emerald-700" />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* 3. CENTERED LOGO LAYER */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16">
//           <div className="absolute w-[220px] h-[220px] bg-white rounded-full blur-[70px] opacity-90" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-1000 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Warranty Mitra Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_12px_24px_rgba(22,163,74,0.18)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[40vh] max-w-md mx-auto w-full">
//         {children}
//       </div>

//       {/* CUSTOM ANIMATION STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0); }
//         }
//         .animate-marquee-slow {
//           animation: marquee 40s linear infinite;
//         }
//         .animate-marquee-reverse-slow {
//           animation: marquee-reverse 45s linear infinite;
//         }
//       `}} />
//     </div>
//   );
// }
//******************************************************************************************************* */
// // src/components/auth/AuthLayout.jsx
// export default function AuthLayout({ children, topLogo }) {
//   return (
//     <div className="min-h-screen w-full relative bg-[#f4fbf6] flex flex-col overflow-hidden">
      
//       {/* PREMIUM LIGHT MESH BACKGROUND */}
//       <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-white to-[#e6f4ea]">
        
//         {/* Soft floating orbs for depth */}
//         <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#bbf7d0] blur-[90px] opacity-60" />
//         <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-[#86efac] blur-[100px] opacity-40" />

//         {/* Centered Logo with a soft glow */}
//         <div className="absolute inset-0 flex items-center justify-center pb-16">
//           <div className="absolute w-[200px] h-[200px] bg-white rounded-full blur-[60px] opacity-80" />
//           {topLogo && (
//             <div className="relative z-10 animate-in fade-in zoom-in duration-700 ease-out">
//               <img 
//                 src={topLogo} 
//                 alt="Warranty Mitra Logo" 
//                 className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_8px_16px_rgba(22,163,74,0.12)]" 
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* BOTTOM 40% FORM AREA */}
//       <div className="relative z-20 flex-1 flex flex-col justify-end pt-[40vh] max-w-md mx-auto w-full">
//         {children}
//       </div>
//     </div>
//   );
// }
//**************************************************chetan code *************************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({
//   children,
//   showIllustration = true,
// }) {
//   return (
//     <div className="
//       min-h-screen w-full relative overflow-hidden
//       bg-gradient-to-br from-[#F8FAFF] via-[#EAF1FF] to-[#D6E4FF]
//       flex items-center justify-center p-3
//     ">

//       {/* BLURRED BACKGROUND SHAPES */}
//       <div className="absolute -top-40 -left-40 w-[420px] h-[420px] bg-[#A9C8FF] rounded-full blur-[140px] opacity-50" />
//       <div className="absolute top-1/4 -right-48 w-[520px] h-[520px] bg-[#0A5BFF] rounded-full blur-[180px] opacity-30 " />
//       <div className="absolute bottom-0 left-1/4 w-[420px] h-[420px] bg-[#0B2E6F] rounded-full blur-[180px] opacity-25" />


//       {/* CENTERED CARD CONTAINER */}
//       <div className="
//         relative z-10
//         w-full max-w-6xl
//         flex
//         items-center justify-center
//         min-h-[600px]
//       ">


//         {/* LEFT ILLUSTRATION */}
//         {/* {showIllustration && (
//           <div className="hidden lg:flex w-1/2 items-center justify-center">
//             <motion.img
//               src={require("../../images/login.webp")}
//               alt="Login Illustration"
//               initial={{ opacity: 0, x: -40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//               className="max-w-[420px] w-full"
//             />
//           </div>
//         )} */}

//         {/* RIGHT CONTENT */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center">
//           {children}
//         </div>

//       </div>
//     </div>
//   );
// }


/************************************************************************************************************************* */
// // components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({ children, showIllustration = true }) {
//   return (
//     <div className="min-h-screen relative flex overflow-hidden bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100">

//       {/* Decorative blobs */}
//       <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute top-1/3 -right-24 w-96 h-96 bg-indigo-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-purple-400 rounded-full blur-3xl opacity-30" />

//       {/* Illustration */}
//       {showIllustration && (
//         <div className="hidden lg:flex w-1/2 items-center justify-center p-10">
//           <motion.img
//             src={require("../../asset/images/login.webp")}
//             alt="Auth Illustration"
//             initial={{ opacity: 0, x: -40 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.5 }}
//             className="max-w-md w-full max-h-96"
//           />
//         </div>
//       )}

//       {/* Content */}
//       <div className="w-full lg:w-1/2 flex items-center justify-center px-4">
//         {children}
//       </div>
//     </div>
//   );
// }
